import apiClient from "./axios.config";

const ongoingService = {
  ongoingServicesBooking(formData) {
    return apiClient.post(`/owners/booking/ongoing`, formData);
  },
  completeServicesBooking(formData) {
    return apiClient.post(`/owners/booking/completed`, formData);
  },
  cancelServicesBooking(bookingGuid) {
    return apiClient.post(`/owners/booking/cancel/${bookingGuid}`);
  },
  reqouetServicesBooking(bookingGuid) {
    return apiClient.put(
      `/owners/booking/accept-requote?bookingGuid=${bookingGuid}`
    );
  },
  bookingDetails(bookingGuid) {
    return apiClient.get(`/owners/booking/${bookingGuid}`);
  },
  reviewServicesBooking(formData) {
    return apiClient.post(`/owners/booking/write-review`, formData);
  },
  reviewbookingDetails(bookingGuid) {
    return apiClient.get(`/owners/booking/review?bookingGuid=${bookingGuid}`);
  },
};

export default ongoingService;
